import { render, staticRenderFns } from "./Scene23.vue?vue&type=template&id=18801f36&scoped=true"
import script from "./Scene23.vue?vue&type=script&lang=js"
export * from "./Scene23.vue?vue&type=script&lang=js"
import style0 from "./Scene23.vue?vue&type=style&index=0&id=18801f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18801f36",
  null
  
)

export default component.exports